import { BreadCrumbs as BreadCrumbsComponent } from '../../components/BreadCrumbs';
import { useSelector } from 'react-redux';
import { breadcrumbsSelector } from '../../selectors/newbuilding';

export const BreadCrumbs = () => {
  const breadCrumbs = useSelector(breadcrumbsSelector);

  if (breadCrumbs.length === 0) {
    return null;
  }

  return <BreadCrumbsComponent breadCrumbs={breadCrumbs} />;
};
